import Resizer from "react-image-file-resizer";

export const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      125,
      167,
      "jpeg",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

export const checkAspectRatio = async (imageFile) => {
  //Get new image
  const img = new Image();
  img.src = window.URL.createObjectURL(imageFile);
  await img.decode();

  if (parseFloat(parseFloat(img.width / img.height).toFixed(2)) === 0.67) {
    return true;
  } else {
    return false;
  }
};
